export default {
  data() {
    return {
      items: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    goToHelp() {
      const hasTickets = this.$store.state.settings.module_tickets === true;
      this.$router.push(hasTickets ? '/tickets' : '/feedback');
    },
    GetFaq() {
      const app = this;
      app.$store.getters.ax
        .post('feedback/api/feedback/faq-by-topic')
        .then((response) => {
          app.items = response.data.items.filter(item => item.is_published);
        });
    },
  },
  mounted() {
    this.GetFaq();
    this.$store.dispatch('SetTitle', 'Часто задаваемые вопросы');
  },
};
